import { FC, ChangeEvent, ReactNode } from 'react';
import cx from 'classnames';

import { SvgIcon } from '@/components';

import styles from './InputCheckbox.module.sass';

export interface InputCheckboxProps {
  id: string;
  name: string;
  value: boolean;
  onChange: (newValue: boolean) => void;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  readOnly?: boolean;
  required?: boolean;
  isError?: boolean;
}

const InputCheckbox: FC<InputCheckboxProps> = (props) => {
  const {
    id,
    name,
    value,
    onChange,
    children,
    className = '',
    disabled = false,
    readOnly = false,
    required = false,
    isError = false,
  } = props;

  const changeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };

  const wrapperClassName = cx(
    className,
    styles.checkbox,
    isError && styles.error,
  );

  return (
    <label htmlFor={id} className={wrapperClassName}>
      <input
        id={id}
        name={name}
        type="checkbox"
        className={styles.input}
        checked={value}
        onChange={changeHandler}
        disabled={disabled}
        readOnly={readOnly}
        required={required}
      />
      <span className={styles.inner}>
        <span className={styles.icon}>
          <SvgIcon name="checkbox" className={styles.checkmark} />
        </span>
        <span className={styles.content}>{children}</span>
      </span>
    </label>
  );
};

export default InputCheckbox;
